__turbopack_context__.v({
  "content": "ShareFeedback-module-scss-module__9pEGAq__content",
  "fadeIn": "ShareFeedback-module-scss-module__9pEGAq__fadeIn",
  "formWrapper": "ShareFeedback-module-scss-module__9pEGAq__formWrapper",
  "loadingOverlay": "ShareFeedback-module-scss-module__9pEGAq__loadingOverlay",
  "sending": "ShareFeedback-module-scss-module__9pEGAq__sending",
  "success": "ShareFeedback-module-scss-module__9pEGAq__success",
  "successDescription": "ShareFeedback-module-scss-module__9pEGAq__successDescription",
  "successIcon": "ShareFeedback-module-scss-module__9pEGAq__successIcon",
  "successTitle": "ShareFeedback-module-scss-module__9pEGAq__successTitle",
});
